// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K7TJ","content":"styles_content__thb9x","row":"styles_row__2bhzk","footer":"styles_footer__3nyog","phraseLength":"styles_phraseLength__2N3MR"};